<!--
 * @Description: 股东
 * @Date: 2025-05-20 18:02:01
-->
<template>
  <div class="account-info__items account-info__multiple">
    <BaseTextTitle class="account-info__items__title">
      <span style="margin-right: 35px">股东信息</span>
      <template v-if="!disabled">
        <BaseButton :disabled="addDisabled" @click="onAdd">新增</BaseButton>
        <span style="font-size: 14px; color: red">最多填写4组股东信息</span>
      </template>
    </BaseTextTitle>
    <BaseTextContent
      v-for="(item, index) in formData.fyShareholderInfoList"
      :key="index + '_' + Date.now()"
      class="account-info__content"
    >
      <BaseButton
        class="account-info__multiple__delete"
        v-if="index && !disabled"
        @click="onDelete(index)"
      >
        删除
      </BaseButton>
      <BaseFormItem
        label="姓名"
        :prop="defProp(index, 'name')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="item.name"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="证件类型"
        :prop="defProp(index, 'certTp')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          :options="CERT_TP_OPTIONS"
          @change="onChangeCertTp(item)"
          v-model="item.certTp"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem
        label="手机号"
        :prop="defProp(index, 'mobile')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="tel"
          placeholder="请输入"
          clearable
          :maxlength="11"
          v-model="item.mobile"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="证件号"
        :prop="defProp(index, 'certNo')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          inputTextReplace
          :inputTexts="['英文字母', '数字']"
          v-model="item.certNo"
        ></BaseInput>
      </BaseFormItem>
      <BizFormTimes
        class="account-info__block"
        label="证件有效期"
        :startProp="defProp(index, 'validDateStart')"
        :endProp="defProp(index, 'validDateEnd')"
        v-model:start="formData.fyShareholderInfoList[index].validDateStart"
        v-model:end="formData.fyShareholderInfoList[index].validDateEnd"
      />

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        :label="!+item.certTp ? '身份证照片（人像面）' : '营业执照'"
        :prop="defProp(index, 'portraitFilePath')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="portraitFilePathRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('fyShareholderInfoList.portraitFilePath', index);
              return true;
            }
          "
          v-model:fileList="uploadModelMap[defProp(index, 'portraitFilePath')]"
          @change="
            v =>
              onUploadChange(v, 'fyShareholderInfoList.portraitFilePath', index)
          "
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过5M;
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <!-- 只有身份证类型展示 -->
      <BaseFormItem
        style="grid-column-start: 3; grid-column-end: 5"
        v-if="!+item.certTp"
        label="身份证照片（国徽面）"
        :prop="defProp(index, 'badgeFilePath')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="badgeFilePathRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('fyShareholderInfoList.badgeFilePath', index);
              return true;
            }
          "
          v-model:fileList="uploadModelMap[defProp(index, 'badgeFilePath')]"
          @change="
            v => onUploadChange(v, 'fyShareholderInfoList.badgeFilePath', index)
          "
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过5M
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseSelect,
  BaseTextContent,
  BaseTextTitle,
  BaseButton
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';

const CERT_TP_OPTIONS = [
  { label: '身份证', value: '0' },
  { label: '营业执照', value: '1' }
];

const { formData, formRef, disabled } = storeToRefs(infoStore());
const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, [
    'fyShareholderInfoList.portraitFilePath',
    'fyShareholderInfoList.badgeFilePath'
  ]);

const addDisabled = computed(() => {
  return formData.value.fyShareholderInfoList.length >= 4 || disabled.value;
});

const defProp = (index, key) => {
  return `fyShareholderInfoList.${index}.${key}`;
};
const onChangeCertTp = item => {
  // 切换类型清空当前证件信息
  item.portraitFilePath = '';
  item.badgeFilePath = '';
};

const onAdd = () => {
  if (disabled.value) return;
  formData.value.fyShareholderInfoList.push({
    name: '', // 股东姓名
    certTp: '0', // 0身份证 1营业执照
    certNo: '', // 证件号
    validDateStart: '', // 证件有效期起
    validDateEnd: '', // 证件有效期止
    portraitFilePath: '', // 身份证正，营业执照
    badgeFilePath: '', // 身份证反，无营业执照
    mobile: ''
  });
};
const onDelete = index => {
  if (!index) return;
  formData.value.fyShareholderInfoList.splice(index, 1);
};
</script>
